import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Profile } from './profiles.models';
import { ProfileConfigDialogState, ProfilesState } from './profiles.reducer';

export const getProfilesState = createFeatureSelector<ProfilesState>('profiles');

// Profiles list selectors
export const getSelectedProfile = createSelector(getProfilesState, (state: ProfilesState) =>
  state.profiles.find(profile => profile.id === state.selectedProfileId)
);

export const getSelectedProfileId = createSelector(getProfilesState, (state: ProfilesState) => state.selectedProfileId);

export const getProfiles = createSelector(getProfilesState, (profileState: ProfilesState) => profileState.profiles);

export const getProfileCount = createSelector(
  getProfilesState,
  (profileState: ProfilesState) => profileState.profiles.length
);

export const getProfileById = (profileId: number) => {
  return createSelector(getProfilesState, (profileState: ProfilesState) => {
    return profileState.profiles.find(profile => profile.id === profileId);
  });
};

export const getActiveProfiles = createSelector(getProfiles, (profiles: Profile[]) =>
  profiles.filter(x => x.isActive === true && x.isVisible === true)
);

export const getDisabledProfiles = createSelector(getProfiles, (profiles: Profile[]) =>
  profiles.filter(x => x.isActive !== true && x.isVisible === true)
);

// Profile Dialog selectors
export const getProfileDialogState = createSelector(getProfilesState, (profileState: ProfilesState) => {
  return profileState.configDialogState;
});

export const getDialogIsLoading = createSelector(
  getProfileDialogState,
  (profileDialogState: ProfileConfigDialogState) => {
    return profileDialogState.isLoading;
  }
);

export const getDialogProfile = createSelector(
  getProfileDialogState,
  (profileDialogState: ProfileConfigDialogState) => {
    return profileDialogState.profileConfig;
  }
);

export const getDialogMcInstances = createSelector(
  getProfileDialogState,
  (profileDialogState: ProfileConfigDialogState) => {
    return profileDialogState.mcInstances;
  }
);

// subscribe to get group list accessible to logged-in user
export const getDialogMcInstanceGroups = createSelector(
  getProfileDialogState,
  (profileDialogState: ProfileConfigDialogState) => {
    return profileDialogState.mcInstanceGroups.filter(group => group.hasGroupAccess);
  }
);

// subscribe to get all groups
export const getDialogAllMcInstanceGroups = createSelector(
  getProfileDialogState,
  (profileDialogState: ProfileConfigDialogState) => {
    return profileDialogState.mcInstanceGroups;
  }
);

export const getProfileFilterState = createSelector(getProfilesState, (profileState: ProfilesState) => {
  return profileState.profileFilterState;
});

export const getProfilePaginationState = createSelector(getProfilesState, (profileState: ProfilesState) => {
  return profileState.profilePaginationState;
});
